/* sakyou-track.js — 左京 自前行動計測タグ v1.2
 *
 * 全ページ共通で読み込み、以下を収集して Cloudflare Workers (sakyou-heatmap) へ送る:
 *   - セクション（ゾーン）別の到達・滞在時間 … LPは .slp 直下ブロック(band内は展開)、他ページは .shopify-section を自動列挙
 *   - スクロール深度 25/50/75/90% と到達時刻
 *   - クリック/タップ座標（ゾーン相対%・文書座標）と対象（CTA種別の判定つき）
 *   - ページ滞在時間（可視状態のみ集計）
 *
 * 設計正本: Marketing/plans/PJ_heatmap_design.md
 * 制約: Cookie/localStorage不使用・個人特定情報を取らない・DOMに一切書き込まない(CLS 0)
 *       読み取り専用のIntersectionObserver+passiveリスナーのみ。失敗しても本文表示に影響しない。
 * v1.1 (crosscheck反映): 背高ゾーンの到達取りこぼし修正 / タブ非表示中のdwell水増し修正 /
 *       送信seq / band展開 / fx判定を子要素まで / 深度のlazy-load誤計上ガード / テキスト取得の最小化
 * v1.2 (Freeze Review B5): layout_sig（レイアウト世代の署名）と tag_v（タグ版）を送信。
 *       ページ改修でゾーン構成が変わった期間をまたいで平均を取らないための識別子
 * v1.3 (S2実測反映): ゾーンIDから template--<数字>__ を除去。Shopifyのテンプレート内部IDが
 *       混ざると、テンプレート再作成のたびに全ゾーンIDが変わり期間比較が切れるため
 */
(function () {
  'use strict';

  var EP = 'https://sakyou-heatmap.sakyou.workers.dev/c'; // 受け口Worker
  var TAG_V = '1.3';  // 計測の意味論を変えたら上げる（到達判定・ゾーンIDの付け方など）
  var SAMPLE = 1; // サンプリング率(0-1)。トラフィック過多になったら下げる

  try {
    if (navigator.webdriver) return;                         // bot/自動テスト
    if (window.top !== window.self) return;                  // iframe内(テーマエディタ等)
    if (window.Shopify && window.Shopify.designMode) return; // テーマカスタマイズ画面
    if (!window.IntersectionObserver || !window.crypto) return; // 旧ブラウザは計測しない(表示は正常)
    if (Math.random() > SAMPLE) return;
  } catch (e) { return; }

  var cfg = window.__stCfg || {}; // theme.liquid が埋める {t: template, h: handle}
  var t0 = Date.now();
  var now = function () { return Date.now() - t0; };

  var pv = (function () {
    var a = new Uint8Array(8);
    window.crypto.getRandomValues(a);
    var s = '';
    for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2);
    return s;
  })();

  function clip(s, n) { return (s == null ? '' : String(s)).replace(/\s+/g, ' ').trim().slice(0, n); }

  // ---- 流入元・ページ情報 -------------------------------------------------
  var q = {};
  try {
    location.search.replace(/^\?/, '').split('&').forEach(function (kv) {
      var p = kv.split('=');
      if (p[0]) q[decodeURIComponent(p[0])] = decodeURIComponent((p[1] || '').replace(/\+/g, ' '));
    });
  } catch (e) { /* noop */ }

  var refDomain = '';
  try {
    if (document.referrer) {
      var rd = new URL(document.referrer).hostname;
      if (rd !== location.hostname) refDomain = clip(rd, 60);
    }
  } catch (e) { /* noop */ }

  // ---- ゾーン(セクション)の自動列挙 --------------------------------------
  // LPページ: .slp 直下のブロック。連続ブロックを包む .slp-band は中身を展開して数える
  //           (bandの有無で集計単位が変わらないように)。anchor idがあればそれを採用
  // 通常ページ: Shopify標準の .shopify-section ラッパー
  var zones = [];
  function collectZones() {
    var els = [], isLp = false;
    var lp = document.querySelector('.slp');
    var src = lp ? lp.children : document.querySelectorAll('.shopify-section');
    if (lp) isLp = true;
    [].forEach.call(src, function (el) {
      if (el.nodeType !== 1 || /^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(el.tagName)) return;
      if (isLp && el.className && String(el.className).indexOf('slp-band') > -1) {
        [].forEach.call(el.children, function (c) { if (c.nodeType === 1) els.push(c); });
      } else {
        els.push(el);
      }
    });
    // 高さでは絞らない: DOMContentLoaded時点では画像が未ロードで高さ0のブロック(hero等)があるため
    var used = {};
    zones = els.map(function (el, i) {
      var id = el.id || '';
      if (id.indexOf('shopify-section-') === 0) id = id.slice(16);
      // ShopifyのJSONテンプレート由来IDは template--<テンプレート内部ID>__ が前置される。
      // この数値はテンプレートを作り直すと変わり、ゾーンIDが全て別物になって
      // 期間比較が切れるため落とす（残る部分はセクション名で安定している）
      id = id.replace(/^template--\d+__/, '');
      if (!id) id = (el.className || 'zone').split(' ')[0] || 'zone';
      if (used[id] != null) id = id + '-' + i;
      used[id] = i;
      var h = el.querySelector('h1,h2,h3');
      var fx = 0;
      try {
        // 追従nav・sticky CTA等。通常テーマではラッパー自体はstaticで直下の子がsticky/fixedの
        // ことが多いため、第1子まで見る
        var pos = getComputedStyle(el).position;
        var c1 = el.firstElementChild;
        var pos1 = c1 ? getComputedStyle(c1).position : '';
        if (pos === 'fixed' || pos === 'sticky' || pos1 === 'fixed' || pos1 === 'sticky') fx = 1;
      } catch (e) { /* noop */ }
      return {
        el: el, i: i, id: clip(id, 60), fx: fx,
        n: clip(h ? h.textContent : (isLp ? '' : el.getAttribute('data-st-name') || ''), 24),
        seen: null,   // 初回可視 ms
        dw: 0,        // 累計可視 ms
        visSince: null,
        wasVis: false // タブ非表示で中断した可視状態の復帰用
      };
    });
  }

  // レイアウト署名: ゾーンIDの並びから求める8桁hex（FNV-1a 32bit）。
  // ページを改修してゾーン構成が変わると値が変わるので、集計時に「レイアウト世代」で
  // 分けられる（別世代の数字を混ぜて平均しないための識別子）
  var layoutSig = '';
  function calcLayoutSig() {
    var src = zones.map(function (z) { return z.id; }).join('|');
    var h = 0x811c9dc5;
    for (var i = 0; i < src.length; i++) {
      h ^= src.charCodeAt(i);
      h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return ('0000000' + h.toString(16)).slice(-8);
  }

  // 「見た」判定: ゾーンの4割が見える、またはゾーンが画面の半分以上を占める
  function isVis(ratio, rectH) {
    return ratio >= 0.4 || rectH >= window.innerHeight * 0.5;
  }
  function markVis(z, vis, t) {
    if (vis) {
      if (z.seen == null) z.seen = t;
      if (z.visSince == null) z.visSince = t;
    } else if (z.visSince != null) {
      z.dw += t - z.visSince;
      z.visSince = null;
    }
  }

  function observeZones() {
    // 閾値を細かく刻む: 背の高いゾーン(ビューポートの2.5倍超)は交差率が0.4に届かず、
    // 粗い閾値だとコールバック自体が発火しない(=永久に未到達になる)ため
    var th = [];
    for (var i = 0; i <= 20; i++) th.push(i / 20);
    var io = new IntersectionObserver(function (entries) {
      var t = now();
      entries.forEach(function (en) {
        var z = null;
        for (var i = 0; i < zones.length; i++) if (zones[i].el === en.target) { z = zones[i]; break; }
        if (!z) return;
        markVis(z, en.isIntersecting && isVis(en.intersectionRatio, en.intersectionRect.height), t);
      });
    }, { threshold: th });
    zones.forEach(function (z) { io.observe(z.el); });
  }

  // スクロール時の補完判定: IntersectionObserverの閾値の隙間に落ちた未到達ゾーンを拾う保険
  function sweepUnseen() {
    var t = now();
    var vh = window.innerHeight;
    for (var i = 0; i < zones.length; i++) {
      var z = zones[i];
      if (z.seen != null) continue;
      var r = z.el.getBoundingClientRect();
      if (r.height <= 0) continue;
      var visiblePx = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (visiblePx > 0 && isVis(visiblePx / r.height, visiblePx)) markVis(z, true, t);
    }
  }

  // ---- スクロール深度 -----------------------------------------------------
  // 画像lazy-load中はscrollHeightが最終値より小さく深度が過大に出るため、
  // マイルストーンはページload完了後にのみ記録する
  var maxScroll = 0;
  var mile = { 25: null, 50: null, 75: null, 90: null };
  var ticking = false;
  function measureDepth() {
    if (document.readyState !== 'complete') return;
    var dh = document.documentElement.scrollHeight || 1;
    var pct = Math.min(100, Math.round((window.pageYOffset + window.innerHeight) / dh * 100));
    if (pct > maxScroll) {
      maxScroll = pct;
      [25, 50, 75, 90].forEach(function (m) { if (pct >= m && mile[m] == null) mile[m] = now(); });
    }
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      measureDepth();
      sweepUnseen();
    });
  }

  // ---- クリック/タップ ----------------------------------------------------
  var clicks = [];
  function zoneAt(clientX, clientY, pageY) {
    var i, r;
    // 固定/追従要素は最前面に重なるので先に判定（ビューポート座標で当たりを取る）
    for (i = 0; i < zones.length; i++) {
      if (!zones[i].fx) continue;
      r = zones[i].el.getBoundingClientRect();
      if (r.height > 0 && clientY >= r.top && clientY <= r.bottom && clientX >= r.left && clientX <= r.right) {
        return { z: zones[i], top: r.top + window.pageYOffset, h: r.height || 1 };
      }
    }
    for (i = 0; i < zones.length; i++) {
      if (zones[i].fx) continue;
      r = zones[i].el.getBoundingClientRect();
      var top = r.top + window.pageYOffset;
      if (pageY >= top && pageY <= top + r.height) {
        return { z: zones[i], top: top, h: r.height || 1 };
      }
    }
    return null;
  }
  function ctaKind(t) {
    if (!t) return 'ui';
    var href = t.getAttribute('href') || '';
    var form = t.form || (t.closest ? t.closest('form') : null);
    var action = form ? (form.getAttribute('action') || '') : '';
    if (action.indexOf('/cart/add') > -1 || href.indexOf('/cart/add') > -1) return 'cart';
    if (/lin\.ee|line\.me/.test(href)) return 'line';
    if (/^tel:/.test(href)) return 'tel';
    if (/^https?:/.test(href) && href.indexOf(location.hostname) === -1) return 'ext';
    if (href && href !== '#') return 'nav';
    return 'ui';
  }
  function onClick(e) {
    try {
      if (clicks.length >= 120) return;
      var target = e.target && e.target.closest
        ? e.target.closest('a,button,[role="button"],input[type="submit"],summary,label')
        : null;
      var kind = ctaKind(target);
      var hit = zoneAt(e.clientX, e.clientY, e.pageY);
      var dh = document.documentElement.scrollHeight || 1;
      // テキストはCTA系のみ40字まで(ログイン中ヘッダーの顧客名リンク等を拾わないため)。
      // 遷移系はリンク先パスで内容を識別する(こちらに個人情報は乗らない)
      var tx = '', hp = '';
      if (kind === 'cart' || kind === 'line' || kind === 'tel') {
        tx = clip(target ? (target.textContent || target.value) : '', 40);
      } else if ((kind === 'nav' || kind === 'ext') && target) {
        try {
          var u = new URL(target.getAttribute('href'), location.href);
          // 外部リンクは遷移先ドメインが本質情報なのでホスト名も残す
          hp = clip(kind === 'ext' ? u.hostname + u.pathname : u.pathname, 60);
        } catch (err) { /* noop */ }
      }
      clicks.push({
        t: now(),
        x: Math.round(e.clientX / window.innerWidth * 1000) / 10,   // ビューポート幅%
        y: Math.round(e.pageY / dh * 1000) / 10,                    // 文書高%(全体ヒートマップ用)
        z: hit ? hit.z.id : '',
        zy: hit ? Math.round((e.pageY - hit.top) / hit.h * 1000) / 10 : null, // ゾーン内%(端末幅に依存しない)
        el: target ? target.tagName.toLowerCase() : (e.target && e.target.tagName || '').toLowerCase(),
        tx: tx, hp: hp,
        k: kind
      });
      if (kind === 'cart' || kind === 'line') flush(true); // CV級クリックは離脱前に即時送信
    } catch (err) { /* noop */ }
  }

  // ---- 滞在時間(可視のみ) -------------------------------------------------
  var engaged = 0;
  var visStart = document.visibilityState === 'visible' ? now() : null;
  function settleVis() {
    var t = now();
    if (document.visibilityState === 'visible') {
      if (visStart == null) visStart = t;
      // タブ復帰: 非表示前に可視だったゾーンの計時を再開
      zones.forEach(function (z) { if (z.wasVis) { z.visSince = t; z.wasVis = false; } });
    } else {
      if (visStart != null) { engaged += t - visStart; visStart = null; }
      // タブ非表示: ゾーンのdwellも精算して止める(アプリ切替→数分後に戻る、の水増し防止)
      zones.forEach(function (z) {
        if (z.visSince != null) { z.dw += t - z.visSince; z.visSince = null; z.wasVis = true; }
      });
    }
  }

  // ---- 送信 ---------------------------------------------------------------
  var lastFlush = -9999;
  var seq = 0;
  function payload() {
    var t = now();
    var dev = window.innerWidth < 600 ? 'mobile' : window.innerWidth < 900 ? 'tablet' : 'desktop';
    return JSON.stringify({
      v: 1,
      pv: pv,
      seq: ++seq, // 到着順が入れ替わっても古いスナップショットで上書きしないための通し番号
      tv: TAG_V,
      lsig: layoutSig,
      path: clip(location.pathname, 200),
      tpl: clip(cfg.t, 40),
      handle: clip(cfg.h, 80),
      variant: clip(window.__slpVariant || q.v, 20), // LPのA/Bテストが表示した案（例 h1b）を優先。確認用の ?v= はテストが記録しないときだけ
      ref: refDomain,
      us: clip(q.utm_source, 60), um: clip(q.utm_medium, 60), uc: clip(q.utm_campaign, 80),
      dev: dev, vw: window.innerWidth, vh: window.innerHeight,
      dh: document.documentElement.scrollHeight,
      eng: Math.round(engaged + (visStart != null ? t - visStart : 0)),
      sc: { max: maxScroll, t25: mile[25], t50: mile[50], t75: mile[75], t90: mile[90] },
      zones: zones.map(function (z) {
        var r = z.el.getBoundingClientRect();
        return {
          i: z.i, id: z.id, n: z.n, fx: z.fx,
          top: z.fx ? null : Math.round(r.top + window.pageYOffset), h: Math.round(r.height),
          s: z.seen == null ? null : Math.round(z.seen),
          dw: Math.round(z.dw + (z.visSince != null ? t - z.visSince : 0))
        };
      }),
      clicks: clicks
    });
  }
  function flush(force) {
    try {
      var t = now();
      if (!force && t - lastFlush < 3000) return; // 連投防止
      lastFlush = t;
      var body = payload();
      if (navigator.sendBeacon) {
        navigator.sendBeacon(EP, new Blob([body], { type: 'text/plain' }));
      } else if (window.fetch) {
        fetch(EP, { method: 'POST', body: body, keepalive: true });
      }
    } catch (e) { /* noop */ }
  }

  // ---- 起動 ---------------------------------------------------------------
  function start() {
    collectZones();
    if (!zones.length) return;
    layoutSig = calcLayoutSig();
    observeZones();
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('click', onClick, true);
    document.addEventListener('visibilitychange', function () { settleVis(); if (document.visibilityState === 'hidden') flush(true); });
    window.addEventListener('pagehide', function () { settleVis(); flush(true); });
    // レイアウト確定後に初期深度を記録（bfcache復帰等で既にcompleteの場合は即時）
    if (document.readyState === 'complete') { onScroll(); }
    else { window.addEventListener('load', function () { onScroll(); }); }
    setTimeout(function () { flush(); }, 10000); // 途中離脱に備え10秒時点で一度送る
    setTimeout(function () { flush(); }, 45000); // 長滞在の中間スナップショット
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
